import { EType as EOrderStatusType } from '../../../../node/repositories/offer-card/entities/newbuilding_flat_view_order/OrderStatusSchema';
import { IState } from '../../../store';

export function getIsFlatViewOrderBooked(state: IState): boolean {
  return state.offerData?.newbuildingFlatViewOrder?.orderStatus?.type === EOrderStatusType.SignedUp;
}
